export const OBJECT_PRODUCT_PRESET_SUBTYPE_DESCRIPTIONS: Record<
  string,
  string
> = {
  'phone-case/slim-shell':
    'A thin phone shell that protects the back while leaving the front open.',
  'phone-case/bumper':
    'A reinforced phone frame that leaves the back open or visibly clear.',
  'phone-case/rugged':
    'A thick protective phone shell with reinforced corners.',
  'phone-case/folio':
    'A phone cradle attached to a hinged cover that closes over the front.',
  'phone-case/wallet':
    'A phone cradle combined with integrated storage for cards.',
  'phone-case/battery':
    'A protective phone shell expanded to house an integrated battery.',
  'phone-case/kickstand':
    'A protective phone shell with a folding stand built into the back.',
  'phone-case/flip':
    'A phone cradle with a front cover hinged along its short edge.',
  'phone-case/holster':
    'A protective phone case paired with an external belt-mounted cradle.',
  'phone-case/armband':
    'A phone pocket or cradle attached to an integrated arm strap.',
  'phone-case/lanyard':
    'A protective phone shell with an attached neck or wrist cord.',
  'phone-case/grip-case':
    'A protective phone shell with an integrated hand grip on the back.',

  'notebook/hardcover':
    'A bound page block protected by rigid front and back boards.',
  'notebook/softcover':
    'A bound page block enclosed by a flexible outer cover.',
  'notebook/spiral-bound':
    'A notebook with individually punched pages held by a wire or coil spine.',
  'notebook/lay-flat':
    'A notebook whose binding opens fully into flat paired page spreads.',
  'notebook/pocket': 'A compact bound notebook sized for easy portable use.',
  'notebook/journal':
    'A personal-scale notebook made from bound pages for writing.',
  'notebook/planner':
    'A bound notebook organized around dated or structured planning pages.',
  'notebook/composition':
    'A school-proportioned notebook with a fixed sewn or glued spine.',
  'notebook/travelers':
    'A wraparound notebook cover designed to hold replaceable slim inserts.',
  'notebook/ring-bound':
    'A notebook with opening rings that hold removable punched pages.',
  'notebook/refillable':
    'A reusable notebook cover built to accept a replaceable page block.',

  'toys/plush': 'A soft stuffed toy with a sewn three-dimensional body.',
  'toys/building-set':
    'A toy set of multiple pieces joined through a repeatable connection system.',
  'toys/stacking':
    'A toy of graduated pieces designed to balance in a stable stack.',
  'toys/figurine':
    'A small freestanding toy shaped as one character or creature.',
  'toys/vehicle':
    'A toy with a recognizable vehicle body and a rolling-style base.',
  'toys/puzzle':
    'A toy of interlocking pieces that resolve into one assembled target.',
  'toys/pretend-play-set':
    'A coordinated set of role-play objects designed to be used together.',
  'toys/doll':
    'A toy with a humanlike or character body intended for posing or dressing.',
  'toys/pull-along':
    'A wheeled toy body designed to move from a cord at the front.',
  'toys/musical':
    'A child-operated toy instrument with controls that produce playable sounds.',
  'toys/sensory':
    'A hand-scale interactive toy composed of multiple tactile elements.',
  'toys/activity-toy':
    'A self-contained toy body organized into multiple interactive stations.',
};
